import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { UpdatePasswordInterface } from '../../models/update-password.interface';
import { UpdatePassword } from '../../store/actions/customer.actions';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { AlertMessageInterface } from '../../../shared/models/alert-message.interface';
import { GetAlertMessage } from '../../../shared/store/actions/alert-message.actions';
import { UpdateSelectedProcedure } from '../../../shared/store/actions/selected-procedure.actions';
import { TogglePasswordService } from '../../../authentication/services/toggle-password.service';
import { UpdateMfaVisibility } from '../../../shared/store/actions/mfa.actions';


@Component({
    selector: 'app-update-password',
    templateUrl: './update-password.component.html',
    styleUrls: ['./update-password.component.css'],
    standalone: false
})
export class UpdatePasswordComponent implements OnInit {

  passwordForm: FormGroup;
  passwordFormSubmitted: boolean;
  updatePassword: UpdatePasswordInterface;

  constructor(
      private router: Router,
      private formBuilder: FormBuilder,
      private store: Store<any>,
      public togglePasswordService: TogglePasswordService
  ) {}

  ngOnInit() {
    this.passwordFormSubmitted = false;
    this.initPasswordForm();
  }

  /**
   * Init password form
   */
  initPasswordForm() {
    this.passwordForm = this.formBuilder.group({});
    this.passwordForm.addControl('password', this.formBuilder.control('', [Validators.required]));
    this.passwordForm.addControl('newPassword', this.formBuilder.control('', [Validators.required, Validators.pattern(ConstsHelper.passwordPattern)]));
    this.passwordForm.addControl('confirmationPassword', this.formBuilder.control('', [Validators.required, Validators.pattern(ConstsHelper.passwordPattern)]));
  }

  /**
   * Save password
   */
  savePassword() {
    this.passwordFormSubmitted = true;
    if (this.passwordForm.valid) {
      this.updatePassword = {
        password: this.passwordForm.get('password').value,
        newPassword: this.passwordForm.get('newPassword').value,
        confirmationPassword: this.passwordForm.get('confirmationPassword').value
      } as UpdatePasswordInterface;
      this.passwordFormSubmitted = false;
      if (this.updatePassword.newPassword !== this.updatePassword.confirmationPassword) {
        const alertMessage = {
          message: ConstsHelper.ERROR_MESSAGE_UPDATE_NOT_IDENTICAL_PASSWORD,
          code: 400
        } as AlertMessageInterface;
        this.store.dispatch(new GetAlertMessage(alertMessage));
      } else {
        this.store.dispatch(
            new UpdateMfaVisibility(
                {
                  visibility: true,
                  action: 'change_password',
                  step: 1,
                  destination: null,
                  code: null,
                  errorMessage: null,
                  effect: UpdatePassword,
                  effectData: this.updatePassword
                }
            )
        );
      }
    }
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }
}
